import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconItalicSvg } from "./IconItalicSvg.mjs";
const IconItalic = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconItalicSvg, ...svgProps }) });
export {
  IconItalic
};
